import { Box, Button, Typography } from '@mui/material'
import CustomDialog from '../CustomDialog'

interface ConfirmReassignProps {
  isOpen: boolean
  handleSubmit: () => void
  handleClose: () => void
}

const BimNonEditableModalComponent: React.FC<ConfirmReassignProps> = ({
  isOpen,
  handleSubmit,
  handleClose,
}) => {
  return (
    <CustomDialog
      isOpen={isOpen}
      title=''
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      hideActions={true}
    >
      <Box
        gap='1.5rem'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '27rem',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: '1.25rem',
        }}
      >
        <Typography
          sx={{
            color: '#797979',
            fontSize: '0.9rem',
            fontWeight: 500,
            lineHeight: 'normal',
            textAlign: 'center',
          }}
        >
          BIM element is non-editable. This element’s dimensions cannot be
          changed and must remain as is.
        </Typography>
        <Box gap='0.75rem' display='flex'>
          <Button
            variant='outlined'
            size='small'
            onClick={() => handleClose()}
            sx={{
              width: '10rem',
              color: '#1705E5',
              background: '#fff',
              border: '1px solid #1705E5',
              fontSize: '0.84rem',
              textTransform: 'none',
            }}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            size='small'
            onClick={() => handleSubmit()}
            sx={{
              width: '10rem',
              color: '#fff',
              background: '#1705E5',
              fontSize: '0.84rem',
              textTransform: 'none',
            }}
          >
            Proceed
          </Button>
        </Box>
      </Box>
    </CustomDialog>
  )
}

export default BimNonEditableModalComponent
